module.exports = __webpack_public_path__ + "fonts/comment-exclamation.svg";